var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeOptimisee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 135.5,
    y: 198.7,
    width: 229,
    height: 185
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148,
    y: 116.6,
    width: 204,
    height: 110
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162,208c-9.7,0-17.5,7.9-17.5,17.5v131.4c0,9.7,7.8,17.5,17.5,17.5h176c9.7,0,17.5-7.9,17.5-17.5v-87.4c0-9.7-7.9-17.5-17.5-17.5h-79.9c-14.6,0-26.5-11.9-26.5-26.5s-7.9-17.5-17.5-17.5h-52.2ZM338.1,383.4h-176c-14.6,0-26.5-11.9-26.5-26.5v-131.4c0-14.6,11.9-26.5,26.5-26.5h52.2c14.6,0,26.5,11.9,26.5,26.5s7.9,17.5,17.5,17.5h79.9c14.6,0,26.5,11.9,26.5,26.5v87.4c0,14.6-11.9,26.5-26.5,26.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M348.4,225.7c-1.4,0-2.6-1.2-2.6-2.6v-101.4h-170.1c-11.8,0-21.4,9.6-21.4,21.4v38.1c0,1.4-1.2,2.6-2.6,2.6s-2.6-1.2-2.6-2.6v-38.1c0-14.7,11.9-26.6,26.6-26.6h175.2v106.5c0,1.4-1.1,2.6-2.6,2.6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.6,157.6h-25.8c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9h25.8c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.1,157.6h-64.2c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9h64.2c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329.3,157.6h-25.8c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9h25.8c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.6,183.6h-25.8c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9h25.8c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M282.1,183.6h-64.2c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9h64.2c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329.3,183.6h-25.8c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9h25.8c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.5,237.9c4.2,0,4.2-6.5,0-6.5s-4.2,6.5,0,6.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeOptimisee);
export default __webpack_public_path__ + "static/media/Icone_optimisee.de48fb06bd9023d455bd384a1ad06ce5.svg";
export { ForwardRef as ReactComponent };